module.exports = __webpack_public_path__ + "img/banner_title2.7692cd1b.png";